import { render, staticRenderFns } from "./MainMenu.vue?vue&type=template&id=a6bafe1c"
import script from "./MainMenu.vue?vue&type=script&lang=js"
export * from "./MainMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\Azure-Agent\\_work\\25\\s\\packages\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6bafe1c')) {
      api.createRecord('a6bafe1c', component.options)
    } else {
      api.reload('a6bafe1c', component.options)
    }
    module.hot.accept("./MainMenu.vue?vue&type=template&id=a6bafe1c", function () {
      api.rerender('a6bafe1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MainMenu.vue"
export default component.exports